import { useCollection } from "api/hooks/useCollection";
import { Collections, Season } from "api/model";
import { SelectOption } from "ui/componentes";
import { useMemo } from "react";

export const useSeasonOptions = () => {
    const seasons =
        useCollection<Season[]>(
            { collection: Collections.SEASONS, orderBy: ["endAt", "asc"] },
            true
        ) || [];
    const seasonsOptions: SelectOption[] = useMemo(
        () =>
            seasons
                .map((season) => ({
                    value: season.id,
                    label: `${season.year} ${season.name} ${
                        season.current ? "- atual" : ""
                    }`,
                }))
                .sort((op1, op2) => (op1.label > op2.label ? 1 : -1)),
        [seasons]
    );
    return seasonsOptions;
};
